import { Invite } from '@/api';
import { createContext } from 'react';

export interface InvitesContextData {
    invites: Invite[];
}
export const InvitesContext = createContext<InvitesContextData | undefined>(
    undefined
);
